import { loadImage } from '../utils/image';

// 合并多张衣服分割图
export async function mergeHumanParsingMaskImages(urls: string[]): Promise<string> {
    const canvas = document.createElement('canvas');

    // 并行加载图片
    const images = await Promise.all(urls.map(loadImage));
    const width = images[0].width;
    const height = images[0].height;

    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')!;

    for (const img of images) {
        // 创建中间 canvas 来处理每一张图
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = width;
        tempCanvas.height = height;
        const tempCtx = tempCanvas.getContext('2d')!;

        // 绘制当前图像
        tempCtx.drawImage(img, 0, 0, width, height);

        // 处理当前图像数据，保留白色，其他透明
        const imageData = tempCtx.getImageData(0, 0, width, height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

            // // 判断是否为白色像素
            // if (!(r === 255 && g === 255 && b === 255)) {
            //   data[i + 3] = 0; // 非白色设为透明
            // }
            // 判断是否为白色像素
            if (!(r > 127 && g > 127 && b > 127)) {
                data[i + 3] = 0; // 非白色设为透明
            }
            //  // 判断是否为黑色像素
            // if ((r === 0 && g === 0 && b === 0)) {
            //   data[i + 3] = 0; // 非黑色设为透明
            // }
        }

        tempCtx.putImageData(imageData, 0, 0);

        // 把每张处理后的图叠加到主 canvas
        ctx.drawImage(tempCanvas, 0, 0);
    }

    return canvas.toDataURL('image/png');
}
